import React from 'react';
import Hero from './components/sedg-cell/Hero';
import Main from './components/sedg-cell/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const SedgCell = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default SedgCell;